export const locale = {
  lang: "it",
  data: {
    STRUCTURE_COST: "Costo struttura",
    MENU: {
      WORKDAY_COLLABORATORS_REPORTS: "Rapportini ore mensili collaboratori",
    },
    STATUS: {
      NOT_GENERATED: "Non generato",
    },
    BY_PROVIDER: "Da fornitore",
    NOT_BY_PROVIDER: "Escludi da fornitore",
    YOU_CANNOT_SEND_REPORT_BECAUSE_WITHOUT_COMMISSION: "Non puoi inviare il rapportino perché non hai commesse associate a te.",
    PLEASE_CONTACT_ADMINISTRATION: "Contatta l'amministrazione.",
    MISSING_COMMISSIONS_FOR_WORKING_DAY_MINE: "Mancano commesse dal giorno DATA in poi, contatta l'amministrazione prima di inviare il rapportino.",
    MISSING_COMMISSIONS_FOR_WORKING_DAY: "Mancano commesse dal giorno DATA in poi."
  },
};
